import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'mile-express-checkpoints-process';
  isDarkMode = false;

  ngOnInit(): void {
    // 🔹 Lê o tema salvo no localStorage (se existir)
    const savedTheme = localStorage.getItem('theme');
    this.isDarkMode = savedTheme === 'dark';

    // 🔹 Aplica o tema salvo ao body
    document.body.classList.toggle('dark-theme', this.isDarkMode);
    document.body.classList.toggle('light-theme', !this.isDarkMode);
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;

    // 🔹 Alterna classes no body
    document.body.classList.toggle('dark-theme', this.isDarkMode);
    document.body.classList.toggle('light-theme', !this.isDarkMode);

    // 🔹 Salva no localStorage
    localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
  }
}
